import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Toast from '@common/components/vue/dida/toast/index.js'

import { BrowserTracing } from '@sentry/tracing'
import * as Sentry from 'dida-sentry-vue-sdk'
import packageInfo from '../package.json'
import Env from '@common/libs/util.env'
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    Vue,
    release: packageInfo.name + '@' + packageInfo.version,
    environment: Env.isEnvOnline ? 'online' : (Env.isEnvECS ? 'simu' : 'test'),
    dsn: 'https://ce0af080a6b64ba5bd439b1a73b34958@sentry.didapinche.com/29', // 此处填写sentry平台创建应用后获取到的dsn
    integrations: [new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router), // 如果未使用 vue-router，此行删掉
        tracingOrigins: ['localhost', 'capis.didapinche.com', 'capis-ecs.didapinche.com', 'capis-test.didapinche.com']
    })],
    tracesSampleRate: 1.0
  })
}

Vue.use(Toast)
Vue.config.productionTip = false

const mixin = {
  methods: {
    goto(path, isReplace) {
      if (!isReplace) {
        this.$router.replace(path)
      } else {
        this.$router.push(path)
      }
    }
  }
}
Vue.mixin(mixin)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
